var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "marketingProjectManagement" }, [
    _c("iframe", {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "my_iframe",
      attrs: {
        id: "fram",
        width: "100%",
        height: "100%",
        src: _vm.iframeUrl,
        frameborder: "0"
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowCenter,
            expression: "isShowCenter"
          }
        ],
        staticClass: "realTaskAll"
      },
      [
        _c("realTaskmenu", { on: { cut: _vm.cut } }),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          this.$store.state.cutNum == 1
            ? _c(
                "div",
                { staticStyle: { height: "100%" } },
                [
                  _c("classCompany", {
                    attrs: { classCompany: _vm.classCompany },
                    on: {
                      name: function($event) {
                        return _vm.myfuntion()
                      },
                      jumpMgy: _vm.jumpMgy
                    }
                  })
                ],
                1
              )
            : this.$store.state.cutNum == 2
            ? _c(
                "div",
                { staticStyle: { height: "100%" } },
                [
                  _c("marketProjectReview", {
                    attrs: { marketProjectReview: _vm.marketProjectReview },
                    on: {
                      name: function($event) {
                        return _vm.myfuntion()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.showRight
      ? _c("div", { staticClass: "right_wrap" }, [
          _c("div", { staticClass: "showBtn", on: { click: _vm.showHidden } }, [
            _c("img", { attrs: { src: "/static/images/newRealTask/show.png" } })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.rightShow,
                  expression: "rightShow"
                }
              ],
              staticClass: "right_cont"
            },
            [
              _c("div", { staticClass: "header_top" }, [
                _c("h3", [_vm._v("资料箱")]),
                _vm._v(" "),
                _c("img", {
                  attrs: { src: "/static/images/newRealTask/back.png" },
                  on: { click: _vm.goback }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "project-list" }, [
                _c("div", { staticClass: "project-item" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "project-cont" },
                    [
                      _c("el-tree", {
                        ref: "ptree",
                        attrs: {
                          data: _vm.treeData,
                          props: _vm.defaultProps,
                          "default-expand-all": true
                        },
                        on: { "node-click": _vm.handleNodeClick }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("img", { attrs: { src: "/static/images/newRealTask/picon.png" } }),
      _vm._v(" "),
      _c("span", [_vm._v("东航项目包-2021")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55d0cfdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55d0cfdc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/newRealTask/marketingProjectManagement.vue
// module id = null
// module chunks = 